var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonBase } from "@mui/material";
import clsx from "clsx";
import { UiSocialIcon } from "../ui_social_icon";
import { useStyles } from "./ui_social_button.css";
export const UiSocialButton = (_a) => {
    var _b;
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    const classes = useStyles();
    const handleClick = () => {
        onClick(props.medium);
    };
    return (_jsx(ButtonBase, { onClick: handleClick, children: _jsx(UiSocialIcon, Object.assign({}, props, { classes: Object.assign(Object.assign({}, props.classes), { root: clsx((_b = props.classes) === null || _b === void 0 ? void 0 : _b.root, classes.ui_social_icon__button) }) })) }));
};
//# sourceMappingURL=ui_social_button.js.map